"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XoneConnDataFlags = /** @class */ (function () {
    function XoneConnDataFlags() {
    }
    XoneConnDataFlags.PREFIX_MODIFIED = 0x00000001;
    XoneConnDataFlags.CONNSTRING_MODIFIED = 0x00000002;
    XoneConnDataFlags.ROWIDFIELD_MODIFIED = 0x00000004;
    XoneConnDataFlags.SQLFIELD_MODIFIED = 0x00000008;
    XoneConnDataFlags.ROWIDLEN_MODIFIED = 0x00000010;
    XoneConnDataFlags.OPERIDLEN_MODIFIED = 0x00000020;
    XoneConnDataFlags.DATEMASK_MODIFIED = 0x00000040;
    XoneConnDataFlags.TABLEQUOTE_MODIFIED = 0x00000080;
    XoneConnDataFlags.FIELDQUOTE_MODIFIED = 0x00000100;
    XoneConnDataFlags.SUBQUERIES_MODIFIED = 0x00000200;
    return XoneConnDataFlags;
}());
exports.default = XoneConnDataFlags;

//# sourceMappingURL=XoneConnDataFlags.js.map
